import React from 'react';
import './error-message.scss';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className='error-message'>
      <div className='error-message__content'>
        <span className='error-message__text'>{message}</span>
        {onRetry && (
          <button className='error-message__retry-button' onClick={onRetry} type='button'>
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
